/**
 *
 * @param { * 请求获取到的数据 } list
 * @param { * 匹配icon } map
 */
export default (list, map) => {
    const result = [];
    list.forEach(item => {
      let icon = null;
      // 匹配Icon
        if(map[item.id]){
          icon = map[item.id].icon;
        }else {
          icon = 'el-icon-question';
        }
        result.push({ ...item, label: item.name, value: item.id, icon: icon });
    });
    return result;
};
